import { usePage, usePageFragments, useStories } from "../hooks/CmsHooks";
import { usePublicProducts } from "../hooks/ProductHooks";
import { PropsWithChildren } from "react";

const InitializeData = ({
  children,
  skipPreloading = false
}: PropsWithChildren<{
  skipPreloading?: boolean;
}>) => {
  return skipPreloading ? children : <LoadData>{children}</LoadData>;
};

const LoadData = ({ children }: PropsWithChildren) => {
  usePublicProducts();
  usePageFragments(0);
  useStories(0);
  usePage("/");
  return children;
};

export default InitializeData;
